import { useRentalManagerUserPropertyActivateWebApiHandler_activate } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

export const ACTIVATE_LISTING_MUTATION_KEY = ['activateListing'];

export const useActivateListing = () => {
  return useRentalManagerUserPropertyActivateWebApiHandler_activate({
    mutationKey: ACTIVATE_LISTING_MUTATION_KEY,
    meta: {
      context: {
        api: 'rental-manager',
        details: 'useRentalManagerUserPropertyActivateWebApiHandler_activate',
      },
      invalidates: ['users-properties-activate', 'listingDetails', 'getProperties'],
    },
  });
};
